import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone } from 'react-icons/fa';

const About: React.FC = () => {
    const [selectedTrustee, setSelectedTrustee] = useState<number | null>(null);

    const trustees = [
        {
            id: 1,
            name: "Mrs. ISWARYALAKSHMI",
            mobile: "99433 90712",
            relation: "W/o. MR.V.Vishal",
            address: "No. 58/59 F3, DJ Gardens, Arul Garden Extension, Ramamoorthy Road, Selvapuram, Coimbatore – 641026",
            role: "Managing Trustee",
            image: "/partner logo/ISWARYA LAKSHMI.jpg"
        },
        {
            id: 2,
            name: "Mrs. LAKSHMI VENKATESAN",
            mobile: "98422 19221",
            relation: "W/o. Venkatesan",
            address: "No. 58/59 F3, DJ Gardens, Arul Garden Extension, Ramamoorthy Road, Selvapuram, Coimbatore – 641026",
            role: "Trustee",
            image: "/partner logo/Lakshmi venkatesan.jpg"
        },
        {
            id: 3,
            name: "Dr. L. VENKATESAN",
            mobile: "99420 19000",
            relation: "S/o. Lakshmi Narasimman",
            address: "No. 58, 59, F3, DJ Gardens, Arul Garden Extension, Ramamoorthy Road, Selvapuram, Coimbatore – 641026",
            role: "Trustee",
            image: "/partner logo/Dr.Venkatesan.jpg"
        },
        {
            id: 4,
            name: "Mrs. JANAVI",
            mobile: "99443 99821",
            relation: "W/o. Aditya",
            address: "58, 59, DJ Garden, F3, Ramamoorthy Road, Arul Garden Extension, Selvapuram, Coimbatore – 641026",
            role: "Trustee",
            image: "/partner logo/Mrs. JANAVI.jpg"
        }

    ];
    return (
        <section id="about-us" className="py-16 md:py-24 bg-white">
            <div className="container mx-auto px-4">

                {/* Section 1: Mentorship */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center mb-24">
                    <div className="md:col-span-5 relative">
                        <div className="bg-primary/5 absolute top-4 -left-4 w-full h-full rounded-lg -z-0"></div>
                        <img
                            src="/images/women.png"
                            alt="Mentorship"
                            className="rounded-lg shadow-xl w-full h-auto object-cover relative z-10"
                        />
                    </div>
                    <div className="md:col-span-7">
                        <h4 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Who We Are</h4>
                        <h2 className="text-4xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                            About <span className="text-primary">Us</span>
                        </h2>
                        <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                            Our Trust is established with the objective of supporting needy people who require assistance in the areas of education, healthcare, women welfare, and children welfare. We are committed to improving the quality of life of individuals by addressing their essential needs and promoting social well-being.<br /><br />The benefits and services of our Trust are open to all, without any discrimination based on caste, religion, race, gender. We strongly believe in equality, inclusiveness, and compassion in serving society.<br /><br />Our Trust functions with a purely non-profit motive and does not engage in any activities with the intention of earning profit. Every effort and initiative undertaken by the Trust is solely aimed at social service and community development.
                        </p>
                        <Link
                            to="/donation"
                            className="bg-gradient-to-r from-primary to-primary-dark hover:from-primary-light hover:to-primary text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 inline-flex items-center"
                        >
                            Make a Donation
                        </Link>
                    </div>
                </div>

                {/* Section 2: Education & Healthcare */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
                    <div className="md:col-span-7 order-2 md:order-1">
                        <h4 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Our Focus</h4>
                        <h2 className="text-4xl md:text-4xl font-bold text-gray-900 mb-6 leading-relaxed">
                            Support in <span className="text-primary">Education & Healthcare</span>, Women & Child Welfare.
                        </h2>
                        <div className="space-y-6">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 mt-1">
                                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h5 className="text-xl font-bold text-gray-900 mb-2">Education that sparks imagination</h5>
                                    <p className="text-gray-600">Mentorship and learning sit at the heart of our collaboration, nurturing Grampreneurs with guidance and education.</p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 mt-1">
                                    <div className="w-10 h-10 rounded-full bg-secondary/10 flex items-center justify-center text-secondary">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h5 className="text-xl font-bold text-gray-900 mb-2">Healthcare & Welfare</h5>
                                    <p className="text-gray-600">Comprehensive support in healthcare and welfare for women and children designed for sustained impact.</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-8">
                            <Link to="/volunteer" className="bg-primary text-white px-8 py-3 rounded font-semibold hover:bg-primary-dark transition-colors inline-block">
                                Join Us Today
                            </Link>
                        </div>
                    </div>
                    <div className="md:col-span-5 order-1 md:order-2">
                        <div className="relative transform rotate-2 hover:rotate-0 transition-transform duration-500">
                            <img
                                src="/images/education.png"
                                alt="Education"
                                className="rounded-lg shadow-xl w-full h-auto border-8 border-white"
                            />
                            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-dots-pattern opacity-50 z-[-1]"></div>
                        </div>
                    </div>
                </div>

                {/* Section 3: Trustees */}
                <div className="py-16 bg-gradient-to-br from-gray-50 to-white">
                    <div className="container mx-auto px-4">
                        <div className="text-center mb-10 md:mb-12">
                            <h4 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Leadership</h4>
                            <h2 className="text-4xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 leading-relaxed">
                                Our <span className="text-primary">Trustees</span>
                            </h2>
                            <p className="text-gray-600 mb-6 md:mb-8 text-base md:text-lg max-w-3xl mx-auto">
                                The AUTHOR OF THE TRUST has appointed the following persons to hold the office of the Trust as Trustees:
                            </p>
                        </div>

                        {/* Trustee Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                            {trustees.map((trustee) => (
                                <div
                                    key={trustee.id}
                                    className="group relative bg-gradient-to-br from-primary/10 via-white to-secondary/10 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden h-full flex flex-col border-2 border-primary/30 hover:border-primary/50 transform hover:-translate-y-2"
                                >
                                    {/* Card Content */}
                                    <div className="p-6 flex-1 flex flex-col bg-gradient-to-br from-white/95 to-primary/5">
                                        {/* Profile Section */}
                                        <div className="relative mb-4 flex justify-center">
                                            {/* Profile Image/Icon */}
                                            <div className="w-24 h-32 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center overflow-hidden">
                                                {trustee.image ? (
                                                    <img
                                                        src={trustee.image}
                                                        alt={trustee.name}
                                                        className="w-full h-full rounded-full object-cover border-2 border-white"
                                                    />
                                                ) : (
                                                    <svg className="w-12 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                    </svg>
                                                )}
                                            </div>
                                        </div>

                                        {/* Trustee Info */}
                                        <div className="text-center mb-4">
                                            <h3 className="text-base font-bold text-gray-900 mb-1 leading-tight">
                                                {trustee.name}
                                            </h3>
                                            <p className="text-sm text-primary font-semibold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                                                {trustee.role}
                                            </p>
                                        </div>

                                        {/* Contact Info */}
                                        <div className="space-y-2 mb-4 flex-1">
                                            <div className="flex items-center justify-center gap-2 text-sm text-gray-700 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg px-3 py-2 border border-primary/20">
                                                <FaPhone className="w-4 h-4 text-primary" />
                                                <span className="font-medium">{trustee.mobile}</span>
                                            </div>
                                        </div>

                                        {/* View Details Button */}
                                        <div className="mt-auto">
                                            <button
                                                onClick={() => setSelectedTrustee(trustee.id)}
                                                className="w-full bg-gradient-to-r from-primary to-secondary hover:from-primary-dark hover:to-secondary-dark text-white font-semibold py-3 px-4 rounded-lg transition-all duration-300 text-sm shadow-md hover:shadow-lg transform hover:scale-105"
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* 3D Modal */}
                {selectedTrustee && (
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn"
                        onClick={() => setSelectedTrustee(null)}
                    >
                        <div
                            className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto transform-gpu transition-all duration-500 scale-100 animate-slideUp"
                            onClick={(e) => e.stopPropagation()}
                            style={{ transformStyle: 'preserve-3d' }}
                        >
                            {/* Modal Content */}
                            <div className="p-8 relative">
                                {/* Close Button */}
                                <button
                                    onClick={() => setSelectedTrustee(null)}
                                    className="absolute top-4 right-4 w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-300"
                                >
                                    <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>

                                <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center md:items-start">
                                    {/* Left Side - Passport Size Image */}
                                    <div className="flex-shrink-0">
                                        {trustees.find(t => t.id === selectedTrustee)?.image ? (
                                            <img
                                                src={trustees.find(t => t.id === selectedTrustee)?.image}
                                                alt={trustees.find(t => t.id === selectedTrustee)?.name}
                                                className="w-32 h-40 md:w-40 md:h-48 object-cover rounded-lg shadow-lg border-2 border-gray-200"
                                            />
                                        ) : (
                                            <div className="w-32 h-40 md:w-40 md:h-48 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center shadow-lg">
                                                <svg className="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </div>
                                        )}
                                    </div>

                                    {/* Right Side - All Text Content */}
                                    <div className="flex-1 space-y-6">
                                        <div className="text-center md:text-left">
                                            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{trustees.find(t => t.id === selectedTrustee)?.name}</h3>
                                            <p className="text-base md:text-lg text-primary font-semibold">{trustees.find(t => t.id === selectedTrustee)?.role}</p>
                                        </div>

                                        {/* Contact Information */}
                                        <div>
                                            <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                                                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                                                </svg>
                                                Contact Information
                                            </h4>
                                            <div className="space-y-2 text-sm">
                                                <p><span className="font-medium">Mobile:</span> {trustees.find(t => t.id === selectedTrustee)?.mobile}</p>
                                                <p><span className="font-medium">Relation:</span> {trustees.find(t => t.id === selectedTrustee)?.relation}</p>
                                            </div>
                                        </div>

                                        {/* Address */}
                                        <div>
                                            <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                                                <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                Address
                                            </h4>
                                            <p className="text-sm text-gray-600">{trustees.find(t => t.id === selectedTrustee)?.address}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Section 4: Partners */}
                <div className="bg-white py-16 px-4">
                    <div className="container mx-auto">
                        <div className="text-center mb-10 md:mb-12">
                            <h4 className="text-secondary font-bold uppercase tracking-widest mb-2 md:mb-3 text-sm">Our Partners</h4>
                            <h2 className="text-4xl md:text-4xl font-bold text-gray-900 mb-4">
                                Eco <span className="text-primary">System</span>
                            </h2>
                            <p className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto">
                                We collaborate with leading organizations to maximize our impact and reach more communities in need.
                            </p>
                        </div>

                        {/* Partner Logos */}
                        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 max-w-7xl mx-auto px-4">
                            {/* BCBuzz Card */}
                            <a
                                href="https://bcbuzz.io"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center h-56 cursor-pointer"
                            >
                                <img
                                    src="/partner logo/Bcbuzzlogo.png"
                                    alt="BCBuzz"
                                    className="h-full max-h-40 w-auto object-contain p-4"
                                    style={{ filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))' }}
                                />
                            </a>

                            {/* Sheguards Card */}
                            <a
                                href="https://sheguards.org/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center h-56 cursor-pointer"
                            >
                                <img
                                    src="/partner logo/sheguards.png"
                                    alt="Sheguards"
                                    className="h-full max-h-40 w-auto object-contain p-4"
                                    style={{ filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))' }}
                                />
                            </a>

                            {/* CYBERXPERTZ Card */}
                            <a
                                href="https://cyberxpertz.org/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center h-56 cursor-pointer"
                            >
                                <img
                                    src="/partner logo/Cyberxpertz Logo.png"
                                    alt="CYBERXPERTZ"
                                    className="h-full max-h-40 w-auto object-contain p-4"
                                    style={{ filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))' }}
                                />
                            </a>

                            {/* Shri Card */}
                            <a
                                href="https://www.facebook.com/shrinehruvidyalayacbe/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center h-56 cursor-pointer"
                            >
                                <img
                                    src="/partner logo/Shri.png"
                                    alt="Shri"
                                    className="h-full max-h-40 w-auto object-contain p-4"
                                    style={{ filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))' }}
                                />
                            </a>

                            {/* CSI India Card */}
                            <a
                                href="https://csiindia.org/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center h-56 cursor-pointer"
                            >
                                <img
                                    src="/partner logo/computer.png"
                                    alt="CSI India"
                                    className="h-full max-h-40 w-auto object-contain p-4"
                                    style={{ filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))' }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
